import logoCreek from "../../common/assets/logoCreek.png";
import logoNuevamente from "../../common/assets/logoNuevamente.png";
import logoHangover from "../../common/assets/logoHangover.png";
import logoLeparc from "../../common/assets/logoLeparc.png";
import logoKeops from "../../common/assets/logoKeops.png";
import logoQuickpass from "../../common/assets/logoQuickpass.png";
import logoRosario from "../../common/assets/logoRosario.png";
import logoWabi from "../../common/assets/logoWabi.png";
import logoRoof from "../../common/assets/logoRoof.png";
//import logoLeparc from "../../common/assets/logoLeparc.png";


let logo = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    logo = logoCreek;
}else if (tenantId == "nuevamente") {
    logo = logoNuevamente;
}else if (tenantId == "leparc") {
    logo = logoLeparc;
}else if (tenantId == "hangover") {
    logo = logoHangover;
}else if (tenantId == "keops") {
    logo = logoKeops;
}else if (tenantId == "quickpass") {
    logo = logoQuickpass;
}else if (tenantId == "rosario") {
    logo = logoRosario;
}else if (tenantId == "wabi") {
    logo = logoWabi;
}else if (tenantId == "roof") {
    logo = logoRoof;
}


export default logo;


// WEBPACK FOOTER //
// ./src/components/Header/LogoHeader.js